import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiServices } from "../../services/Api.js";
//post login

export const loginData = createAsyncThunk('advisorauth/loginData', async ({ username, password }) => {
    try {
        const response = await apiServices.post(
            '/advisors/login',
            {
                'username': username,
                'password': password
            },
            {},
        );
        return response;
    } catch (error) {
        console.error("Advisor login error:", error);
        throw error;
    }
});


//update password
export const updatePassword = createAsyncThunk(
    'advisorauth/updatePassword',
    async ({ password }) => {
        try {
            console.log('Updating password with:', password);
            const response = await apiServices.update('/advisors/password', {
                password,
            });
            console.log('Password update response:', response);
            return response;
        } catch (error) {
            console.error("Update password error:", error);
            throw error;
        }
    }
);



//logout - Client-side only logout since no server logout endpoint exists
export const LogoutFunc = createAsyncThunk("advisorauth/LogoutFunc", async () => {
    try {
        // Clear authentication data from localStorage and cookies
        localStorage.removeItem("userID");
        document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

        return { success: true, message: "Logged out successfully" };
    } catch (error) {
        console.error("Advisor logout error:", error);
        throw error;
    }
});


const initialState = {
    auth: false,
    token: null,
    loading: false,
    error: "",
    user: [],
    userId: '',
    success: null,
    passwordUpdateSuccess: null,
    isLoggedIn: null,
    test: null,
};

const AdvisorAuthSlice = createSlice({
    name: "advisorauth",
    initialState,

    extraReducers: (builder) => {
        builder
            .addCase(loginData.pending, (state) => {
                state.loading = true;
                state.auth = false;
                state.error = "";
            })
            .addCase(loginData.fulfilled, (state, action) => {
                if (action.payload?.token) {
                    // Successful login
                    state.auth = true;
                    state.loading = false;
                    state.token = action.payload?.token;
                    state.user = [action?.payload?.advisor?.firstName + " " + action?.payload?.advisor?.lastName];
                    state.userId = action?.payload?.advisor?.id;
                    state.isLoggedIn = true;
                    state.success = true;
                    state.error = "";
                    console.log("state authentication", state.user);
                } else {
                    // Unsuccessful login due to 400 status code (Bad Request)
                    state.loading = false;
                    state.auth = false; // Set auth to false
                    state.error = "Username or password incorrect. Please try again.";
                    state.isLoggedIn = false;
                    state.success = false;
                    console.log("state authentication", state.auth);
                }
            })
            .addCase(loginData.rejected, (state, action) => {
                state.loading = false;
                state.auth = false;
                state.error = action.error.message || "Login failed";
                state.isLoggedIn = false;
                state.success = false;
                console.log("Login error:", state.error);
            })
            .addCase(updatePassword.pending, (state) => {
                state.loading = true;
                state.error = "";
                state.passwordUpdateSuccess = null;
            })
            .addCase(updatePassword.fulfilled, (state) => {
                state.loading = false;
                state.error = "";
                state.passwordUpdateSuccess = true;
                console.log("Password updated successfully");
            })
            .addCase(updatePassword.rejected, (state, action) => {
                state.loading = false;
                console.log('Password update rejected:', action.error);
                state.error = action.error.message || "Password update failed";
                state.passwordUpdateSuccess = false;
            })
            // logout
            .addCase(LogoutFunc.pending, (state) => {
                state.loading = true;
            })
            .addCase(LogoutFunc.fulfilled, (state, action) => {
                state.auth = false;
                state.loading = false;
                state.isLoggedIn = false;
                state.token = null;
                state.user = [];
                state.userId = '';
                state.error = '';
                state.success = null;
            })
            .addCase(LogoutFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Logout failed";
            });
    },
});

const AdvisorAuthReducer = AdvisorAuthSlice.reducer;

export default AdvisorAuthReducer;
